import { checkCookies } from "cookies-next";

export function checkLogin(): boolean {
  return checkCookies("access_token");
}
